export function moveCursorToEnd(el: HTMLTextAreaElement | HTMLInputElement) {
	el.focus();
	if (typeof el.selectionStart == "number") {
		el.selectionStart = el.selectionEnd = el.value.length;
	}
	// @ts-ignore
	else if (typeof el.createTextRange != "undefined") {
		// @ts-ignore
		const range = el.createTextRange();
		range.collapse(false);
		range.select();
	}
}
